<div class="modal-background">
  <div class="modal fade show" style="display: block;" id="staticBackdrop" data-backdrop="static" data-keyboard="false"
    tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable bg-dark">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Crear Listado</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="eventos.Closing()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card-body" class="p-4">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-12">
                  <div class="d-flex flex-column">                 
                    <label for="basic-url">Agregar Paquete</label>
                    <div class="input-group mb-3" *ngIf="paquetes">
                      <select class="custom-select resize" id="inputGroupSelect01" (change)="set($event.target.value)">
                        <option selected>Seleccione...</option>
                        <option *ngFor="let item of paquetes" [value]="item._id"> {{item?.titulo}}</option>
                      </select>
                    </div>
                    <label for="basic-url">Costo</label>
                    <div class="input-group mb-3">
                      <input type="text" class="form-control resize" disabled aria-label="Username"
                        aria-describedby="basic-addon1" [(ngModel)]="paquete.price">
                    </div>
                    <label for="basic-url">Fecha de Inicio</label>
                    <div class="input-group mb-3">
                      <input type="date" class="form-control resize" aria-describedby="basic-addon1"
                        [(ngModel)]="fecha_inicio" min="{{set_inicio}}">
                    </div>
                    <button class="btn btn-primary m-1" (click)="save()" *ngIf="!status">
                      Guardar Cambios
                    </button>               
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-modal-loading [show]="modal_loading"></app-modal-loading>
